import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'ticket',
    templateUrl: './ticket.component.html',
    styleUrls: ['./ticket.component.scss']
})
export class TicketComponent {
    public ticketId: string;

    constructor(private activatedRoute: ActivatedRoute) {
        activatedRoute.paramMap.subscribe(paramMap => {
            if (paramMap.keys.length <= 0) return;

            this.ticketId = paramMap.has('id')? paramMap.get('id') : null;
        });
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/pages/ticket.component.ts